// usePageTracking.js - Automatic page view tracking hook
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../context/AnalyticsContext';

// Map routes to readable page names
const PAGE_NAMES = {
  '/': 'Home',
  '/login': 'Login',
  '/setup': 'Setup',
  '/maintenance': 'Maintenance',
  '/calendar': 'Calendar',
  '/recurring-events': 'Recurring Events',
  '/emails': 'Emails',
  '/clients': 'Clients',
  '/work-hours': 'Work Hours',
  '/time-off': 'Time Off',
  '/admin': 'Admin Panel',
  '/dashboard': 'Dashboard',
  '/invoices': 'Invoices',
  '/profile': 'Profile',
  '/changelog': 'Changelog',
};

/**
 * Get readable page name from pathname
 */
const getPageName = (pathname) => {
  // Direct match
  if (PAGE_NAMES[pathname]) {
    return PAGE_NAMES[pathname];
  }

  // Client detail pages (/clients/:id)
  if (pathname.startsWith('/clients/')) {
    return 'Client Detail';
  }

  // Report detail pages (/reports/:id)
  if (pathname.startsWith('/reports/')) {
    return 'Report Detail';
  }

  // Employee detail pages (/employees/:id)
  if (pathname.startsWith('/employees/')) {
    return 'Employee Detail';
  }

  return 'Unknown Page';
};

/**
 * Hook to automatically track page views on route changes
 */
export const usePageTracking = () => {
  const location = useLocation();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    const pageName = getPageName(location.pathname);

    trackPageView(pageName, {
      path: location.pathname,
      search: location.search,
      hash: location.hash,
    });
  }, [location, trackPageView]);
};
